import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output
} from "@angular/core";
import DataSource from "devextreme/data/data_source";
import { catchError, lastValueFrom, of } from "rxjs";
import { MemberBackend } from "src/app/backend/api/member.backend";
import { MemberLight } from "src/app/backend/models/member/member";
import { buildStaffDataSource } from "src/app/support/datasources/staff.datasource";
import { reportError } from "src/app/support/error-reporting";
import { compact } from "es-toolkit";

@Component({
  standalone: false,
  selector: "pms-soap-template-authors",
  templateUrl: "soap-template-authors.component.html",
  styles: `
    :host {
      display: flex;
      flex: 1;
    }
  `
})
export class SoapTemplateAuthorsComponent implements OnInit {
  @Input()
  authors: Array<MemberLight> | undefined;

  @Input()
  preview: boolean = false;

  @Input()
  readOnly: boolean = false;

  @Output()
  data: EventEmitter<{ tags: MemberLight[] }> = new EventEmitter();

  private readonly memberBackend = inject(MemberBackend);

  tags: string[] = [];

  membersDataSource: DataSource;

  constructor() {
    this.membersDataSource = buildStaffDataSource({
      memberBackend: this.memberBackend
    });
  }

  ngOnInit(): void {
    this.tags = this.authors?.map((author) => author.id) || [];
  }

  async onAuthorsChanged(tags: any): Promise<void> {
    if (tags.value) {
      const members: MemberLight[] = compact(
        await Promise.all(
          tags.value.map((tag: string) =>
            lastValueFrom(
              this.memberBackend.loadLight(tag).pipe(
                catchError((error: unknown) => {
                  reportError(error);

                  return of(null);
                })
              )
            )
          )
        )
      );

      this.data.emit({
        tags: members
      });

      this.tags = tags.value;
    }
  }
}
